import { css, cva } from '@/styled-system/css';

export const dropdownContentRecipe = cva({
  base: {
    'display': 'flex',
    'borderRadius': 'obj.soft',
    'flexDirection': 'column',
    'backgroundColor': 'Dropdown.Content.bg',
    'boxShadow': 'md',
    'position': 'relative',
    'overflow': 'hidden',
    'transitionProperty': {
      _motionReduce: 'none',
      _motionSafe: 'opacity, transform',
    },
    'transitionDuration': {
      _motionReduce: '0s',
      _motionSafe: '{durations.250}',
    },
    'transitionTimingFunction': '{easings.ease}',
    '& > .c11n_dropdown__header:first-child > .c11n_dropdown__heading': {
      borderStartStartRadius: 'obj.soft',
      borderStartEndRadius: 'obj.soft',
    },
  },
  variants: {
    open: {
      true: {
        opacity: 1,
        transform: 'none',
      },
      false: {
        opacity: 0,
        transform: 'scale(0.975)',
      },
    },
  },
});

export const dropdownContentPositionerStyles = css.raw({
  zIndex: 'dropdown',
});
